import {FirestoreDocSnapshotWithIdAndData} from '@coolcolduk/firebase-util';
import {mapFirestoreDocWithTimestamp} from '../_other/firestore';
import {ExamModuleDb} from './examModuleDbSchema';
import {ExamModule, examModuleSchema} from './examModuleSchema';

/**
 * Convert exam module db to exam module type
 * @param db ExamModuleDb
 * @returns ExamModule
 */
export function mapExamModuleDbToType(db: FirestoreDocSnapshotWithIdAndData<ExamModuleDb>): ExamModule {
  const data = mapFirestoreDocWithTimestamp(db);
  return examModuleSchema.parse(data);
}
